import React, { Component } from 'react';
import HeaderTitle from '../../GeneralComponents/HeaderTitle';
import Loading from '../../GeneralComponents/LoadingComponen';
import Swal from "sweetalert2/dist/sweetalert2.js";

const CATEGORIES = {
    'Sanciones Internacionales': ['us_ofac_sdn','us_ofac_cons','un_sc_sanctions','eu_fsf','eu_travel_bans','gb_hmt_sanctions','ch_seco_sanctions','ca_dfatd_sema_sanctions','au_dfat_sanctions','jp_mof_sanctions'],
    'Terrorismo y Financiación': ['us_state_terrorist_orgs','us_state_terrorist_exclusion','us_fincen_special_measures','ar_repet'],
    'Buscados / Fugitivos': ['interpol_red_notices','us_fbi_most_wanted','us_dea_fugitives','eu_europol_wanted','gb_nca_most_wanted'],
    'PEPs LATAM': ['co_funcion_publica','co_join_dots','br_pep','uy_pep','cl_info_probidad'],
    'Inhabilitados / Debarment': ['worldbank_debarred','iadb_sanctions','adb_sanctions','afdb_sanctions','ebrd_ineligible','us_sam_exclusions'],
    'Regulatorios Financieros': ['br_ceis','us_sec_pause','ch_finma_warnings','us_finra_actions'],
    'Fuentes Colombianas': ['co_siri_procuraduria','co_secop_multas_i','co_secop_multas_ii','co_peps_sigep','co_policia_capturas'],
};

const HISTORY_KEY = 'sarlaft_search_history';

const DATASET_NAMES = {
    'us_ofac_sdn':                  'OFAC SDN',
    'us_ofac_cons':                 'OFAC Non-SDN',
    'un_sc_sanctions':              'ONU Sanciones',
    'eu_fsf':                       'UE Sanciones',
    'eu_travel_bans':               'UE Prohibiciones Viaje',
    'gb_hmt_sanctions':             'UK HMT',
    'ch_seco_sanctions':            'Suiza SECO',
    'ca_dfatd_sema_sanctions':      'Canada Sanciones',
    'au_dfat_sanctions':            'Australia DFAT',
    'jp_mof_sanctions':             'Japon MOF',
    'us_state_terrorist_orgs':      'EEUU Org. Terroristas',
    'us_state_terrorist_exclusion': 'EEUU Exclusion Terrorismo',
    'us_fincen_special_measures':   'FinCEN 311',
    'ar_repet':                     'Argentina RePET',
    'interpol_red_notices':         'Interpol',
    'us_fbi_most_wanted':           'FBI',
    'us_dea_fugitives':             'DEA Fugitivos',
    'eu_europol_wanted':            'Europol',
    'gb_nca_most_wanted':           'UK NCA',
    'co_funcion_publica':           'PEP Colombia',
    'co_join_dots':                 'Colombia Congresistas',
    'br_pep':                       'PEP Brasil',
    'uy_pep':                       'PEP Uruguay',
    'cl_info_probidad':             'PEP Chile',
    'worldbank_debarred':           'Banco Mundial',
    'iadb_sanctions':               'BID Sanciones',
    'adb_sanctions':                'ADB Sanciones',
    'afdb_sanctions':               'AfDB Sanciones',
    'ebrd_ineligible':              'BERD Inelegibles',
    'us_sam_exclusions':            'EEUU SAM Exclusiones',
    'br_ceis':                      'Brasil CEIS',
    'us_sec_pause':                 'SEC PAUSE',
    'ch_finma_warnings':            'Suiza FINMA',
    'us_finra_actions':             'FINRA',
    'co_siri_procuraduria':         'Procuraduria SIRI',
    'co_secop_multas_i':            'SECOP I Multas',
    'co_secop_multas_ii':           'SECOP II Multas',
    'co_peps_sigep':                'PEPs SIGEP Colombia',
    'co_policia_capturas':          'Policia Nacional'
};

const RISK = {
    high:   { color: '#f44d4d', bg: '#fdf2f2', border: '#f5c6c3', label: 'RIESGO ALTO',         icon: '⚠' },
    medium: { color: '#d4954a', bg: '#fffbeb', border: '#fcd34d', label: 'RIESGO MEDIO',         icon: '●' },
    low:    { color: '#5b8cc9', bg: '#eff6ff', border: '#bfdbfe', label: 'RIESGO BAJO',          icon: 'ℹ' },
    none:   { color: '#6ec084', bg: '#ecfdf5', border: '#a7f3d0', label: 'SIN COINCIDENCIAS',    icon: '✓' },
};

const S = {
    wrap:         { fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif', color: '#0f172a' },
    searchCard:   { background: '#fff', borderRadius: 10, border: '1px solid #e2e8f0', padding: '20px 22px', marginBottom: 16, boxShadow: '0 1px 4px rgba(15,23,42,0.06)' },
    searchTitle:  { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, flexWrap: 'wrap' },
    sarlaftTag:   { fontSize: 11, fontWeight: 600, color: '#64748b', background: '#f1f5f9', borderRadius: 4, padding: '2px 8px', letterSpacing: '0.05em', textTransform: 'uppercase', whiteSpace: 'nowrap' },
    searchRow:    { display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' },
    fieldWrap:    { flex: '1 1 160px', minWidth: 0 },
    fieldLabel:   { display: 'block', fontSize: 11, fontWeight: 600, color: '#475569', marginBottom: 5, letterSpacing: '0.04em', textTransform: 'uppercase' },
    input:        { width: '100%', border: '1px solid #cbd5e1', borderRadius: 7, padding: '9px 13px', fontSize: 14, outline: 'none', color: '#0f172a', background: '#fff', transition: 'border-color .15s' },
    searchBtn:    { flexShrink: 0, background: '#1e3a6e', color: '#fff', border: 'none', borderRadius: 7, padding: '9px 22px', fontSize: 14, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' },
    clearBtn:     { flexShrink: 0, background: 'transparent', color: '#64748b', border: '1px solid #e2e8f0', borderRadius: 7, padding: '9px 14px', fontSize: 14, cursor: 'pointer' },
    resultsCard:  { background: '#fff', borderRadius: 10, border: '1px solid #e2e8f0', marginBottom: 16, boxShadow: '0 1px 4px rgba(15,23,42,0.06)', overflow: 'hidden' },
    riskBanner:   (level) => {
        const r = RISK[level] || RISK.none;
        return { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 28px', background: r.color, color: '#fff' };
    },
    riskLabel:    { fontSize: 20, fontWeight: 800, letterSpacing: '0.03em' },
    riskSub:      { fontSize: 12, opacity: 0.8, marginTop: 2 },
    riskCount:    { textAlign: 'right' },
    riskNum:      { fontSize: 42, fontWeight: 900, lineHeight: 1 },
    riskNumLabel: { fontSize: 11, opacity: 0.8, display: 'block', marginTop: 2 },
    resultsBody:  { padding: '16px 20px' },
    catHeader:    { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', background: '#f8fafc', borderRadius: 7, border: '1px solid #e2e8f0', cursor: 'pointer', marginBottom: 2, userSelect: 'none' },
    catTitle:     { fontWeight: 700, fontSize: 13, color: '#1e3a6e', display: 'flex', alignItems: 'center', gap: 8 },
    catCount:     { fontSize: 11, fontWeight: 700, color: '#fff', background: '#1e3a6e', borderRadius: 20, padding: '1px 9px', minWidth: 22, textAlign: 'center' },
    catBlock:     { marginBottom: 12 },
    table:        { width: '100%', borderCollapse: 'collapse', fontSize: 12 },
    th:           { padding: '8px 12px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#475569', borderBottom: '2px solid #e2e8f0', background: '#f8fafc', letterSpacing: '0.04em', textTransform: 'uppercase' },
    td:           { padding: '9px 12px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'top', color: '#0f172a', fontSize: 13 },
    tdHL:         { padding: '9px 12px', borderBottom: '1px solid #fef3c7', verticalAlign: 'top', color: '#0f172a', fontSize: 13, background: '#fffbeb' },
    nameMain:     { fontWeight: 600, color: '#0f172a' },
    nameSub:      { fontSize: 11, color: '#94a3b8', marginTop: 2 },
    pill:         (bg, text) => ({ display: 'inline-block', fontSize: 11, fontWeight: 700, color: text || '#fff', background: bg, borderRadius: 4, padding: '2px 7px', marginLeft: 4 }),
    chipDark:     { display: 'inline-block', fontSize: 11, fontWeight: 600, color: '#fff', background: '#334155', borderRadius: 4, padding: '2px 7px' },
    chipBlue:     { display: 'inline-block', fontSize: 11, fontWeight: 600, color: '#1e40af', background: '#dbeafe', borderRadius: 4, padding: '2px 7px' },
    scoreHigh:    { display: 'inline-block', fontSize: 11, fontWeight: 700, color: '#fff', background: '#f44d4d', borderRadius: 4, padding: '2px 7px' },
    scoreMed:     { display: 'inline-block', fontSize: 11, fontWeight: 700, color: '#fff', background: '#d4954a', borderRadius: 4, padding: '2px 7px' },
    scoreLow:     { display: 'inline-block', fontSize: 11, fontWeight: 700, color: '#fff', background: '#5b8cc9', borderRadius: 4, padding: '2px 7px' },
    qualHigh:     { display: 'inline-block', fontSize: 11, fontWeight: 700, color: '#fff', background: '#f44d4d', borderRadius: 4, padding: '2px 7px' },
    qualMed:      { display: 'inline-block', fontSize: 11, fontWeight: 700, color: '#fff', background: '#d4954a', borderRadius: 4, padding: '2px 7px' },
    qualLow:      { display: 'inline-block', fontSize: 11, fontWeight: 700, color: '#94a3b8', background: '#f1f5f9', borderRadius: 4, padding: '2px 7px' },
    idBadge:      { display: 'inline-block', fontSize: 10, fontWeight: 700, color: '#fff', background: '#6ec084', borderRadius: 4, padding: '1px 6px', marginLeft: 5 },
    metaRow:      { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 20px', borderTop: '1px solid #e2e8f0', flexWrap: 'wrap', gap: 10 },
    metaText:     { fontSize: 12, color: '#64748b', display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' },
    actionBtns:   { display: 'flex', gap: 8 },
    btnExport:    { fontSize: 13, fontWeight: 600, color: '#fff', background: '#059669', border: 'none', borderRadius: 7, padding: '8px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 },
    btnPdf:       { fontSize: 13, fontWeight: 600, color: '#fff', background: '#f44d4d', border: 'none', borderRadius: 7, padding: '8px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 },
    emptyState:   { padding: '48px 28px', textAlign: 'center' },
    emptyIcon:    { fontSize: 40, color: '#cbd5e1', marginBottom: 12 },
    emptyTitle:   { fontSize: 16, fontWeight: 700, color: '#1e3a6e', marginBottom: 6 },
    emptyDesc:    { fontSize: 13, color: '#64748b', marginBottom: 24, maxWidth: 440, margin: '0 auto 24px' },
    sourceGrid:   { display: 'flex', flexWrap: 'wrap', gap: 6, justifyContent: 'center', marginTop: 16 },
    sourceBadge:  { fontSize: 11, fontWeight: 600, color: '#1e40af', background: '#eff6ff', borderRadius: 20, padding: '4px 12px', border: '1px solid #bfdbfe' },
    historyRow:   { display: 'flex', flexWrap: 'wrap', gap: 6, justifyContent: 'center', marginTop: 12 },
    histBtn:      { fontSize: 12, color: '#475569', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6, padding: '4px 12px', cursor: 'pointer' },
    noResults:    { padding: '40px 28px', textAlign: 'center' },
    noResultsIcon:{ fontSize: 36, color: '#6ec084', marginBottom: 12 },
};

class Index extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            query: '',
            identifier: '',
            minScore: 0.9,
            includeApi: true,
            isLoading: false,
            hasSearched: false,
            result: null,
            sources: [],
            sourcesLoading: true,
            collapsedCategories: {},
            searchHistory: [],
            queryId: null,
            checkingPdf: false,
            quota: null
        }
    }

    componentDidMount() {
        this.loadSources();
        this.loadSearchHistory();
        this.loadQuota();
    }

    loadQuota = () => {
        fetch('/sarlaft-listas/quota', {
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(r => r.json())
        .then(data => this.setState({ quota: data }))
        .catch(() => {});
    }

    loadSearchHistory = () => {
        try {
            const stored = localStorage.getItem(HISTORY_KEY);
            if (stored) this.setState({ searchHistory: JSON.parse(stored) });
        } catch(e) {}
    }

    saveSearchHistory = (query, identifier) => {
        try {
            const entry = { query: query || '', identifier: identifier || '', date: new Date().toISOString() };
            const prev = this.state.searchHistory.filter(h => !(h.query === entry.query && h.identifier === entry.identifier));
            const updated = [entry, ...prev].slice(0, 5);
            localStorage.setItem(HISTORY_KEY, JSON.stringify(updated));
            this.setState({ searchHistory: updated });
        } catch(e) {}
    }

    loadSources = () => {
        fetch('/sarlaft-listas/sources', {
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(r => r.json())
        .then(data => this.setState({ sources: data.sources || [], sourcesLoading: false }))
        .catch(() => this.setState({ sourcesLoading: false }));
    }

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSearch = (e) => {
        e.preventDefault();
        const { query, identifier } = this.state;
        if (!query.trim() && !identifier.trim()) {
            Swal.fire({ position: "center", type: "warning", title: "Debe ingresar un nombre o numero de identificacion", showConfirmButton: true });
            return;
        }
        this.setState({ isLoading: true, hasSearched: true, queryId: null });
        fetch('/sarlaft-listas/search', {
            method: 'POST',
            body: JSON.stringify({ query: this.state.query, identifier: this.state.identifier, min_score: this.state.minScore, include_api: this.state.includeApi }),
            headers: { "X-CSRF-Token": this.token, "Content-Type": "application/json" }
        })
        .then(r => r.json().then(d => ({ status: r.status, data: d })))
        .then(({ status, data }) => {
            if (status === 403 && data.quota_exceeded) {
                this.setState({ isLoading: false, hasSearched: false, quota: data.quota });
                Swal.fire({
                    type: "warning",
                    title: "Cuota mensual agotada",
                    text: data.error,
                    confirmButtonText: "Entendido"
                });
                return;
            }
            this.saveSearchHistory(this.state.query, this.state.identifier);
            this.setState({ result: data, isLoading: false, queryId: data.query_id || null });
            this.loadQuota();
        })
        .catch(() => {
            Swal.fire({ position: "center", type: "error", title: "Error al realizar la busqueda", showConfirmButton: true });
            this.setState({ isLoading: false });
        });
    }

    handleDownloadPdf = () => {
        const { queryId } = this.state;
        if (!queryId) {
            Swal.fire({ type: 'warning', title: 'PDF no disponible', text: 'Realice una busqueda primero.' });
            return;
        }
        this.setState({ checkingPdf: true });
        fetch(`/sarlaft-listas/historial/${queryId}/pdf_status`, {
            headers: { "X-CSRF-Token": this.token, "Accept": "application/json" }
        })
        .then(r => r.json().then(d => ({ status: r.status, data: d })))
        .then(({ status, data }) => {
            this.setState({ checkingPdf: false });
            if (status === 200 && data.ready && data.url) {
                window.open(data.url, '_blank');
            } else {
                Swal.fire({
                    type:  'info',
                    title: 'PDF en procesamiento',
                    text:  'Estamos generando su PDF. Intente nuevamente en unos segundos.',
                    timer: 3500,
                    showConfirmButton: true
                });
            }
        })
        .catch(() => {
            this.setState({ checkingPdf: false });
            Swal.fire({ type: 'error', title: 'Error', text: 'No se pudo verificar el estado del PDF.' });
        });
    }

    toggleCategory = (cat) => {
        this.setState(prev => ({
            collapsedCategories: { ...prev.collapsedCategories, [cat]: !prev.collapsedCategories[cat] }
        }));
    }

    groupMatchesByCategory = (matches) => {
        const groups = {};
        const allCatDatasets = Object.values(CATEGORIES).flat();
        Object.entries(CATEGORIES).forEach(([cat, datasets]) => {
            const catMatches = matches.filter(m => datasets.includes(m.dataset));
            if (catMatches.length > 0) groups[cat] = catMatches;
        });
        const others = matches.filter(m => !allCatDatasets.includes(m.dataset));
        if (others.length > 0) groups['Otras Fuentes'] = others;
        return groups;
    }

    handleClear = () => {
        this.setState({ query: '', identifier: '', hasSearched: false, result: null });
    }

    formatDataset = (dataset) => DATASET_NAMES[dataset] || dataset;

    scoreStyle = (score) => score >= 0.9 ? S.scoreHigh : score >= 0.7 ? S.scoreMed : S.scoreLow;
    qualStyle  = (q) => q === 'high' ? S.qualHigh : q === 'medium' ? S.qualMed : S.qualLow;
    qualLabel  = (q) => q === 'high' ? 'ALTA' : q === 'medium' ? 'MEDIA' : 'BAJA';

    renderQuotaPill() {
        const { quota } = this.state;
        if (!quota) return null;
        if (quota.unlimited) {
            return (
                <span style={{ fontSize: 11, fontWeight: 600, color: '#059669', background: '#ecfdf5', border: '1px solid #a7f3d0', borderRadius: 20, padding: '3px 10px' }}>
                    <i className="fas fa-infinity" style={{ marginRight: 5 }}></i>Ilimitado
                </span>
            );
        }
        const used = quota.used || 0;
        const limit = quota.limit || 0;
        const pct = limit > 0 ? (used / limit) : 0;
        const level = pct >= 1 ? 'exhausted' : pct >= 0.8 ? 'warning' : 'ok';
        const colors = {
            ok:        { bg: '#eff6ff', border: '#bfdbfe', text: '#1e40af' },
            warning:   { bg: '#fffbeb', border: '#fcd34d', text: '#b45309' },
            exhausted: { bg: '#fee2e2', border: '#fca5a5', text: '#b91c1c' }
        }[level];
        return (
            <span style={{ fontSize: 11, fontWeight: 600, color: colors.text, background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 20, padding: '3px 10px', whiteSpace: 'nowrap' }}>
                <i className="fas fa-bolt" style={{ marginRight: 5 }}></i>
                {used}/{limit} este mes
                {quota.extra > 0 && <span style={{ marginLeft: 4, opacity: 0.75 }}>(+{quota.extra})</span>}
            </span>
        );
    }

    renderSkeleton() {
        const shimmer = {
            background: 'linear-gradient(90deg, #eef2f7 0%, #f8fafc 50%, #eef2f7 100%)',
            backgroundSize: '200% 100%',
            animation: 'sarlaftShimmer 1.4s ease-in-out infinite',
            borderRadius: 6
        };
        const Bar = ({ w, h = 12, mt = 0, mb = 0 }) => (
            <div style={{ ...shimmer, width: w, height: h, marginTop: mt, marginBottom: mb }} />
        );
        return (
            <>
                <style>{`@keyframes sarlaftShimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
                <div style={S.resultsCard}>
                    {/* Banner de riesgo skeleton */}
                    <div style={{ padding: '18px 28px', background: '#f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ flex: 1 }}>
                            <Bar w="40%" h={22} mb={6} />
                            <Bar w="60%" h={10} />
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <Bar w={48} h={34} mb={6} />
                            <Bar w={80} h={10} />
                        </div>
                    </div>

                    <div style={{ padding: '16px 20px' }}>
                        {[1, 2, 3].map(i => (
                            <div key={i} style={{ marginBottom: 16 }}>
                                {/* Categoria header */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', background: '#f8fafc', borderRadius: 7, border: '1px solid #e2e8f0', marginBottom: 4 }}>
                                    <Bar w={180} h={12} />
                                    <Bar w={26} h={16} />
                                </div>
                                {/* Filas */}
                                {[1, 2].map(j => (
                                    <div key={j} style={{ display: 'flex', gap: 16, padding: '12px 14px', borderBottom: '1px solid #f1f5f9' }}>
                                        <div style={{ flex: 2 }}>
                                            <Bar w="70%" h={13} mb={6} />
                                            <Bar w="45%" h={10} />
                                        </div>
                                        <div style={{ flex: 1 }}><Bar w="80%" h={12} /></div>
                                        <div style={{ flex: 1 }}><Bar w="60%" h={12} /></div>
                                        <div style={{ flex: 1.5 }}><Bar w="85%" h={12} /></div>
                                        <div style={{ flex: 0.6, textAlign: 'center' }}><Bar w={44} h={16} /></div>
                                        <div style={{ flex: 0.6, textAlign: 'center' }}><Bar w={44} h={16} /></div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '14px 20px', borderTop: '1px solid #e2e8f0' }}>
                        <Bar w={220} h={11} />
                        <Bar w={140} h={32} />
                    </div>
                </div>
            </>
        );
    }

    renderSearchForm() {
        const { query, identifier, isLoading, hasSearched, quota } = this.state;
        const blocked = quota && !quota.unlimited && quota.exceeded;
        return (
            <div style={S.searchCard}>
                <div style={S.searchTitle}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', flex: '1 1 auto' }}>
                        <i className="fas fa-shield-alt" style={{ color: '#1e3a6e', fontSize: 16 }}></i>
                        <span style={{ fontWeight: 700, fontSize: 15, color: '#1e3a6e' }}>Consulta de Listas Restrictivas</span>
                        <span style={S.sarlaftTag}>SARLAFT / AML</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        {this.renderQuotaPill()}
                        <a href="/sarlaft-listas/historial"
                           style={{ fontSize: 12, fontWeight: 600, color: '#1e3a6e', textDecoration: 'none', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 7, padding: '6px 14px', display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap' }}>
                            <i className="fas fa-history"></i> Ver historial
                        </a>
                    </div>
                </div>
                {blocked && (
                    <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 7, padding: '10px 14px', marginBottom: 12, color: '#991b1b', fontSize: 13 }}>
                        <i className="fas fa-exclamation-triangle" style={{ marginRight: 6 }}></i>
                        <strong>Cuota mensual agotada.</strong> Ha realizado {quota.used} de {quota.limit} consultas permitidas este mes. Contacte al administrador para ampliar la cuota.
                    </div>
                )}
                <form onSubmit={this.handleSearch}>
                    <div style={S.searchRow}>
                        <div style={S.fieldWrap}>
                            <label style={S.fieldLabel}>Nombre</label>
                            <input
                                style={S.input}
                                type="text"
                                name="query"
                                value={query}
                                onChange={this.handleInputChange}
                                placeholder="Nombre completo"
                                autoComplete="off"
                            />
                        </div>
                        <div style={S.fieldWrap}>
                            <label style={S.fieldLabel}>Identificacion</label>
                            <input
                                style={S.input}
                                type="text"
                                name="identifier"
                                value={identifier}
                                onChange={this.handleInputChange}
                                placeholder="Cedula / NIT / Pasaporte"
                                autoComplete="off"
                            />
                        </div>
                        <button type="submit" style={{ ...S.searchBtn, opacity: (isLoading || blocked) ? 0.5 : 1, cursor: blocked ? 'not-allowed' : 'pointer' }} disabled={isLoading || blocked}>
                            {isLoading ? (
                                <><i className="fas fa-spinner fa-spin"></i> Buscando...</>
                            ) : (
                                <><i className="fas fa-search"></i> Consultar</>
                            )}
                        </button>
                        {hasSearched && (
                            <button type="button" style={S.clearBtn} onClick={this.handleClear} title="Limpiar">
                                <i className="fas fa-times"></i>
                            </button>
                        )}
                    </div>
                </form>
            </div>
        );
    }

    renderEmptyState() {
        const { searchHistory } = this.state;
        const showcaseSources = ['OFAC SDN', 'ONU Sanciones', 'UE Sanciones', 'PEP Colombia', 'UK HMT', 'Interpol', 'FBI', 'DEA Fugitivos', 'Banco Mundial', 'BID Sanciones', 'Procuraduria SIRI', 'PEPs SIGEP Colombia'];
        return (
            <div style={{ ...S.resultsCard }}>
                <div style={S.emptyState}>
                    <div style={S.emptyIcon}><i className="fas fa-shield-alt"></i></div>
                    <div style={S.emptyTitle}>Sistema de Screening SARLAFT</div>
                    <div style={{ ...S.emptyDesc, margin: '8px auto 20px' }}>
                        Consulte si una persona natural o juridica se encuentra reportada en listas restrictivas internacionales.
                    </div>
                    <div style={S.sourceGrid}>
                        {showcaseSources.map(s => (
                            <span key={s} style={S.sourceBadge}>{s}</span>
                        ))}
                        <span style={{ ...S.sourceBadge, color: '#64748b', background: '#f8fafc', borderColor: '#e2e8f0' }}>+25 fuentes mas</span>
                    </div>
                    {searchHistory.length > 0 && (
                        <div style={{ marginTop: 28 }}>
                            <div style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>Recientes</div>
                            <div style={S.historyRow}>
                                {searchHistory.map((h, i) => (
                                    <button key={i} style={S.histBtn} onClick={() => this.setState({ query: h.query, identifier: h.identifier })}>
                                        <i className="fas fa-history" style={{ marginRight: 5, fontSize: 11 }}></i>
                                        {h.query || h.identifier}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    renderMatchTable(matches) {
        return (
            <div style={{ overflowX: 'auto' }}>
                <table style={S.table}>
                    <thead>
                        <tr>
                            <th style={S.th}>Nombre</th>
                            <th style={S.th}>Tipo</th>
                            <th style={S.th}>Pais</th>
                            <th style={S.th}>Programa / Lista</th>
                            <th style={S.th}>Fuente</th>
                            <th style={{ ...S.th, textAlign: 'center' }}>Similitud</th>
                            <th style={{ ...S.th, textAlign: 'center' }}>Calidad</th>
                        </tr>
                    </thead>
                    <tbody>
                        {matches.map((match, idx) => {
                            const tdStyle = match.id_match ? S.tdHL : S.td;
                            return (
                                <tr key={idx}>
                                    <td style={tdStyle}>
                                        <div style={S.nameMain}>
                                            {match.name}
                                            {match.id_match && <span style={S.idBadge}>ID Match</span>}
                                        </div>
                                        {match.alias && match.alias.length > 0 && (
                                            <div style={S.nameSub}>{match.alias.slice(0, 2).join(', ')}{match.alias.length > 2 ? ` +${match.alias.length - 2}` : ''}</div>
                                        )}
                                        {match.identifiers && (
                                            <div style={{ ...S.nameSub, fontFamily: 'monospace' }}>
                                                {match.identifiers.length > 40 ? match.identifiers.substring(0, 40) + '…' : match.identifiers}
                                            </div>
                                        )}
                                    </td>
                                    <td style={tdStyle}>{match.type || '—'}</td>
                                    <td style={{ ...tdStyle, textTransform: 'uppercase', fontWeight: 600, fontSize: 12 }}>{match.country || '—'}</td>
                                    <td style={tdStyle}>
                                        {match.program && <div style={{ marginBottom: 3, fontSize: 12, color: '#475569' }}>{match.program}</div>}
                                        {match.dataset && <span style={S.chipDark}>{this.formatDataset(match.dataset)}</span>}
                                    </td>
                                    <td style={tdStyle}><span style={S.chipBlue}>{match.source}</span></td>
                                    <td style={{ ...tdStyle, textAlign: 'center' }}>
                                        <span style={this.scoreStyle(match.score)}>{Math.round(match.score * 100)}%</span>
                                    </td>
                                    <td style={{ ...tdStyle, textAlign: 'center' }}>
                                        <span style={this.qualStyle(match.match_quality)}>{this.qualLabel(match.match_quality)}</span>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }

    renderResults() {
        const { result, collapsedCategories } = this.state;
        const level = result.risk_level || 'none';
        const risk = RISK[level] || RISK.none;
        const grouped = this.groupMatchesByCategory(result.matches || []);

        return (
            <div style={S.resultsCard}>
                {/* Risk Banner */}
                <div style={S.riskBanner(level)}>
                    <div>
                        <div style={S.riskLabel}>{risk.icon} {risk.label}</div>
                        <div style={S.riskSub}>Consulta: {result.search_term}</div>
                    </div>
                    <div style={S.riskCount}>
                        <div style={S.riskNum}>{result.total_matches}</div>
                        <span style={S.riskNumLabel}>coincidencias</span>
                    </div>
                </div>

                {/* Matches */}
                <div style={S.resultsBody}>
                    {result.matches && result.matches.length > 0 ? (
                        Object.entries(grouped).map(([cat, matches]) => (
                            <div key={cat} style={S.catBlock}>
                                <div style={S.catHeader} onClick={() => this.toggleCategory(cat)}>
                                    <span style={S.catTitle}>
                                        <i className={`fas fa-chevron-${collapsedCategories[cat] ? 'right' : 'down'}`} style={{ fontSize: 11, color: '#94a3b8' }}></i>
                                        {cat}
                                    </span>
                                    <span style={S.catCount}>{matches.length}</span>
                                </div>
                                {!collapsedCategories[cat] && this.renderMatchTable(matches)}
                            </div>
                        ))
                    ) : (
                        <div style={S.noResults}>
                            <div style={S.noResultsIcon}><i className="fas fa-check-circle"></i></div>
                            <div style={{ fontWeight: 700, fontSize: 15, color: '#065f46' }}>Sin coincidencias</div>
                            <div style={{ fontSize: 13, color: '#64748b', marginTop: 6 }}>
                                No se encontraron registros para &ldquo;{result.search_term}&rdquo;
                            </div>
                        </div>
                    )}
                </div>

                {/* Meta + actions */}
                <div style={S.metaRow}>
                    <div style={S.metaText}>
                        <span><i className="fas fa-clock" style={{ marginRight: 5 }}></i>{new Date(result.searched_at).toLocaleString('es-CO')}</span>
                        {result.sources_checked && result.sources_checked.length > 0 && (
                            <span><i className="fas fa-database" style={{ marginRight: 5 }}></i>Fuentes: {result.sources_checked.join(', ')}</span>
                        )}
                    </div>
                    <div style={S.actionBtns}>
                        <button
                            style={{ ...S.btnPdf, opacity: this.state.checkingPdf ? 0.7 : 1 }}
                            onClick={this.handleDownloadPdf}
                            disabled={this.state.checkingPdf}
                            title="Descargar el PDF de esta consulta"
                        >
                            {this.state.checkingPdf ? (
                                <><i className="fas fa-spinner fa-spin"></i> Verificando...</>
                            ) : (
                                <><i className="fas fa-file-pdf"></i> Descargar PDF</>
                            )}
                        </button>
                    </div>
                </div>

                {result.errors && result.errors.length > 0 && (
                    <div style={{ margin: '0 20px 16px', background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: 7, padding: '10px 14px', fontSize: 12, color: '#92400e' }}>
                        <i className="fas fa-exclamation-triangle" style={{ marginRight: 6 }}></i>
                        <strong>Advertencias:</strong>
                        {result.errors.map((err, idx) => <div key={idx} style={{ marginTop: 4 }}>• {err.provider}: {err.error}</div>)}
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { isLoading, hasSearched, result } = this.state;
        return (
            <React.Fragment>
                <HeaderTitle
                    title={"Screening SARLAFT"}
                    subTitle={"Consulta de listas restrictivas y sanciones"}
                    icon="fas fa-search"
                    showNew={false}
                    showFilter={false}
                    is_index={true}
                    url={this.props.current_url}
                />
                <div style={S.wrap}>
                    {this.renderSearchForm()}
                    {isLoading && this.renderSkeleton()}
                    {!isLoading && hasSearched && result && this.renderResults()}
                    {!isLoading && !hasSearched && this.renderEmptyState()}
                </div>
            </React.Fragment>
        );
    }
}

export default Index;
